import { MilesPricingStrategyEnum } from '../../../resources/base/models';
import { DistributionModels } from '../../../resources/base/models/distributionModel';
import { CustomerType } from '../../../resources/base/models/enums';
import { ConvertToFormikInitialValues } from '../../../services/common/miscUtils.types';
import { QuotationFormData } from '../../../types';
import { withdrawalDates } from './fieldset';

export const getInitialValues = (customerType: CustomerType): QuotationFormData => {
  const withdrawalDateValue = customerType === CustomerType.INDIVIDUAL ? withdrawalDates[5] : withdrawalDates[1];
  const quotationData: ConvertToFormikInitialValues<QuotationFormData> = {
    contractMileage: 0,
    annualMileage: 0,
    financedAmount: 0,
    recommendedRV: 0,
    overruledRV: 0,
    overruledRVNetAmount: 0,
    overruledRVPercentage: 0,
    contractRVPercentage: 0,
    contractRVAmount: 0,
    firstInstallmentIsIncreased: false,
    firstInstallmentAmount: 0,
    firstInstallmentAmountPercentage: 0,
    pricingId: '',
    numberOfMonthlyInstallments: 0,
    downPaymentAmount: 0,
    downPaymentAmountPercentage: 0,
    firstInstallmentWithDownPaymentAmount: 0,
    firstInstallmentWithDownPaymentPercentage: 0,
    /*  */
    financialProduct: '',
    duration: 0,
    excessMileagePriceAmount: 0,
    vehicleTotalCost: 0,
    totalDiscountAmount: 0,
    totalDiscountPercentage: 0,
    _minDealerDiscountAmount: 0,
    _minDealerDiscountPercentage: 0,
    milesBonusEcologic: 0,
    milesPrimeCee: 0,
    milesPricingStrategy: MilesPricingStrategyEnum.STANDARD,
    serviceBonus: 0,
    eligibility: 0,
    dealerEffort: 0,
    dealerEffortMax: 0,
    totalAmountInsAndServ: '',
    subsequentInstallment: 0,
    spreadLeasePrice: 0,
    insuranceAndServices: [],
    damagesWaiver: '0',
    // Vehicle Summary Data
    preWarehousePriceHT: 0,
    transportHT: 0,
    priceCatalogueHT: 0,
    grayCardHT: 0,
    preWarehousePriceTTC: 0,
    transportTTC: 0,
    priceCatalogueTTC: 0,
    grayCardTTC: 0,
    optionsHT: 0,
    accesoriesHT: 0,
    deliveryPackageHT: 0,
    optionsTTC: 0,
    accesoriesTTC: 0,
    deliveryPackageTTC: 0,
    // Tire service data
    tireCountSummer: '2',
    tireCountWinter: '2',
    tireCountAllSeasons: '2',
    checkMonthlyPayment: '',
    monthlyPayment: '',
    checkCashPayment: '',
    withdrawalDate: withdrawalDateValue as unknown as number,
    totalServicesCost: 0,
    distributionModel: DistributionModels.Classic,
    milesTemplateId: '',
    milesWarrantyTypeDuration: undefined,
    _milesWarrantyType: undefined,

    // Benefit package
    annualDepreciationNonDeductible: 0,
    fringeBenefitFuelIncluded: 0,
    fringeBenefitFuelExcluded: 0,
    fringeBenefitElectricCars: 0,
    annualCo2Tax: 0,
    annualTaxOnAirPollutants: 0,
  };

  return quotationData as QuotationFormData;
};
